<template>
	<h2 style="font-family:Arial">Página no encontrada</h2>
</template>
<script>
export default {
	name:"notfound"
}
</script>